import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

import queries from '../../../src/utils/queries'

import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ImprOS = ({listOSCl, editOdeS, empresa, allUsuarios, stImpr, hoy}) => {
  // console.log(hoy)
  if(stImpr){
  let modeloFactura = empresa.modeloFactura
  //ACTUALIZAR BD
  async function crudBD(operacionCRUD, args, i) {
    // console.log("CRUD")
        if(args.ctrlCampo === 'CRUD'){
  // console.log(i)
  // console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
    
    //Se utiliza para traer el _id del documento creado
          if(args.ctrl_id === 'SI_ID'){
            if(Object.values(data)[0]._id){
              return Object.values(data)[0]._id
            }else{
              return 0
            }
          }
        }else{
          if(args.ctrlCampo === "MANY"){
            // console.log("MANY")
            // console.log(args)
            await operacionCRUD({
              variables: args
            });
          }
        }
      }
    
    //ENVIO PARA ACTUALIZAR BD
      async function updColecc(crudColecc, argsCrud, totDocCRUD) {
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }
  
    // console.log(listOSCl)
      //GENERAR PDF
      let tamPag = 'letter'
      // if(modeloFactura==="2"){
      //   tamPag = 'A6'
      // }
      // console.log(tamPag)
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: tamPag})
      // Document of 210mm wide and 279mm high
      // let doc = new jsPDF('p', 'mm', [279, 210]);

      // let widthDoc = (doc.internal.pageSize.width)
      // let heightDoc = (doc.internal.pageSize.height)
      // widthDoc para letter es 215.89999999999998 => se aprox a 216
      // heightDoc para letter es 279.4 => se aprox a 279
      let numOS = 0
      let imprOS = false
      let contList = 0
      let actImpresaOS = []

      // listOSCl.forEach((elemento, i) => {
        for(let i=0; i<listOSCl.length; i++){
          let elemento = listOSCl[i]
        // console.log(elemento)
        // console.log(elemento.cliente)
        // console.log(elemento.listOS)
        contList += 1
        let cun = "SIN"
        if(elemento.listOS.cun){
          cun = elemento.listOS.cun
        }
        if(elemento.listOS.numeroOS!==numOS){
          numOS = elemento.listOS.numeroOS
          imprOS = true
        }else{
          imprOS = false
        }
        // "accionBD": this.props.editOdeS,
        if(imprOS){
          let usuarioCreate = elemento.listOS.usuarioCreate
          if(allUsuarios.allUsuarios){
            let indexUsu = allUsuarios.allUsuarios.findIndex(usuario => usuario.email===usuarioCreate)
            if(indexUsu!==-1){
              usuarioCreate = allUsuarios.allUsuarios[indexUsu].nombreUsuario
            }
          }
          // console.log(hoy)
          let fechaImprime = hoy
          if(!fechaImprime){
            console.log(hoy)
            fechaImprime = new Date()
            fechaImprime = (fechaImprime.getFullYear()) + '-' + ((fechaImprime.getMonth()+1)<10?'0'+(fechaImprime.getMonth()+1):(fechaImprime.getMonth()+1)) + '-' + (fechaImprime.getUTCDate()<10?'0'+fechaImprime.getUTCDate():fechaImprime.getUTCDate())
          }
          // console.log(hoy, fechaImprime)
          if(!elemento.listOS.impresa){
            let argsUpd = {
              "numeroOS": elemento.listOS.numeroOS,
              "estadoOS": elemento.listOS.estadoOS,
              "impresa": true,
              "ptosAdic": elemento.listOS.ptosAdic?elemento.listOS.ptosAdic:"",
              "observacAB": elemento.listOS.observacAB,
              "observacCE": elemento.listOS.observacCE,
              "observacCA": elemento.listOS.observacCA,
              "codigoMarquilla": elemento.listOS.codigoMarquilla,
              "codigoTipoDocV": elemento.listOS.codigoTipoDocV,
              "numeroDocumV": elemento.listOS.numeroDocumV,
              "descrRecursoV": elemento.listOS.descrRecursoV,
              "tag": elemento.listOS.tag,
              "horaSolic": elemento.listOS.horaSolic,
              "nombreSolic": elemento.listOS.nombreSolic,
              "fechaImpr": fechaImprime,
              "usuarioImpr": sessionStorage.getItem('userLogin'),
              "fechaClose": elemento.listOS.fechaClose,
              "usuarioClose": elemento.listOS.usuarioClose,
              "fechaCanc": elemento.listOS.fechaCanc,
              "usuarioCanc": elemento.listOS.usuarioCanc,
              "fechaEjec": elemento.listOS.fechaEjec,
              "fechaFra": elemento.listOS.fechaFra    
            }
            actImpresaOS.push(argsUpd)
            // console.log(argsUpd)
          }else{
            if(elemento.listOS.fechaImpr){
              fechaImprime = elemento.listOS.fechaImpr.substr(0, 10)
            }
          }

          let listOS = elemento.listOS
          let cliente = elemento.cliente
          let macOS = []
          let argsUpd = []
          if(listOS.equipos&&listOS.equipos.length>0){
            for(let ii=0; ii<listOS.equipos.length; ii++){
              argsUpd = []
              if(ii<3){
                argsUpd.push(`${listOS.equipos[ii].mac}=>${listOS.equipos[ii].accion.substring(0, 3)}`)
                macOS.push(argsUpd)
              }
            }
          }
          let macCliente = []
          if(cliente.equipos&&cliente.equipos.length>0){
            for(let ii=0; ii<cliente.equipos.length; ii++){
              argsUpd = []
              if(ii<3){
                argsUpd.push(`${cliente.equipos[ii].mac}`)
                macCliente.push(argsUpd)
              }
            }
          }

          // console.log(listOS)
          // console.log(macCliente, macOS)
          let fechaEjec = listOS.fechaEjec.substr(0, 10)

          let direccion = {}
          let dirmayor = {}

          let linea1DNNAnt = ""
          let linea2DNNAnt = ""

          if(listOS.direccion&&listOS.direccion.descrTipoVia1){
            direccion = listOS.direccion
              dirmayor = listOS.dirmayor

            if(cliente.direccion&&cliente.direccion.descrTipoVia1){
              linea1DNNAnt = cliente.direccion.descrTipoVia1?cliente.direccion.descrTipoVia1:""
              linea1DNNAnt += cliente.direccion.numeroTipoVia1?" " + cliente.direccion.numeroTipoVia1:""
              linea1DNNAnt += cliente.direccion.descrTipoVia2?" " + cliente.direccion.descrTipoVia2:""
              linea1DNNAnt += cliente.direccion.numeroTipoVia2?" " + cliente.direccion.numeroTipoVia2:""
              linea1DNNAnt += cliente.direccion.numeroTipoVia2F?" " + cliente.direccion.numeroTipoVia2F:""
              linea1DNNAnt += cliente.direccion.descrTipoUnd1?" " + cliente.direccion.descrTipoUnd1:""
              linea1DNNAnt += cliente.direccion.numeroTipoUnd1?" " + cliente.direccion.numeroTipoUnd1:""
              linea1DNNAnt += cliente.direccion.descrTipoUnd2?" " + cliente.direccion.descrTipoUnd2:""
              linea1DNNAnt += cliente.direccion.numeroTipoUnd2?" " + cliente.direccion.numeroTipoUnd2:""
              
              linea2DNNAnt = cliente.dirmayor.ciudades.nombreCiudad?cliente.dirmayor.ciudades.nombreCiudad:""
              linea2DNNAnt += cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio?" - " + cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio:""
            }
          }else{
            direccion = cliente.direccion
            dirmayor = cliente.dirmayor
          }

          let linea1DNN = ""
          let linea2DNN = ""
        
          if(direccion&&direccion.descrTipoVia1){
            linea1DNN = direccion.descrTipoVia1?direccion.descrTipoVia1:""
            linea1DNN += direccion.numeroTipoVia1?" " + direccion.numeroTipoVia1:""
            linea1DNN += direccion.descrTipoVia2?" " + direccion.descrTipoVia2:""
            linea1DNN += direccion.numeroTipoVia2?" " + direccion.numeroTipoVia2:""
            linea1DNN += direccion.numeroTipoVia2F?" " + direccion.numeroTipoVia2F:""
            linea1DNN += direccion.descrTipoUnd1?" " + direccion.descrTipoUnd1:""
            linea1DNN += direccion.numeroTipoUnd1?" " + direccion.numeroTipoUnd1:""
            linea1DNN += direccion.descrTipoUnd2?" " + direccion.descrTipoUnd2:""
            linea1DNN += direccion.numeroTipoUnd2?" " + direccion.numeroTipoUnd2:""
            linea1DNN = linea1DNN.substr(0, 40)
            
            linea2DNN = dirmayor.ciudades.nombreCiudad?dirmayor.ciudades.nombreCiudad:""
            linea2DNN += dirmayor.ciudades.zonas.barrios.nombreBarrio?" - " + dirmayor.ciudades.zonas.barrios.nombreBarrio:""
            linea2DNN = linea2DNN.substr(0, 40)
          }
          let nombreCli = `${cliente.nombreCliente} ${cliente.apellidoCliente}`
          nombreCli = nombreCli.substr(0, 40)

          let cargoCl = cliente.cargoMensual
          if(listOS.tarifa&&listOS.tarifa.codigoTarifa){
            cargoCl = 0
            const elemento3 = listOS.tarifa
            elemento3.servicios.forEach((elemento, i) => {
              cargoCl += elemento.valorServicios
            })
          }

          let movColecc = []
          argsUpd = []
          listOS.recursos.forEach((listOS1, ii) => {
            if(ii<2){
              argsUpd.push(`${listOS1.tiporec.descrTipoRec}: ${listOS1.numeroDocum} (${listOS1.descrRecurso})`)
              movColecc.push(argsUpd)
            }
          })

          let servAsig = []
          if(cliente.tarifa&&cliente.tarifa.servicios&&cliente.tarifa.servicios.length>0){
            for(let ii=0; ii<cliente.tarifa.servicios.length; ii++){
              argsUpd = []
              if(ii<3){
                argsUpd.push(`${cliente.tarifa.servicios[ii].descripcionServicio}`)
                servAsig.push(argsUpd)
              }
            }
          }
          // let servAsig = []
          // argsUpd = []
          // if(cliente.tarifa&&cliente.tarifa.servicios&&cliente.tarifa.servicios.length>0){
          //   cliente.tarifa.servicios.forEach((elemserv, ii) => {
          //     if(ii<3){
          //       argsUpd.push(`${elemserv.descripcionServicio}`)
          //       servAsig.push(argsUpd)
          //     }
          //   })
          // }

          // console.log(movColecc)
//IMPRIMIR OS MODELO 1 => BUENAVENTURA
// console.log(modeloFactura)
          let saldoCl = `$${cliente.saldoPendiente}`
// let cargoCl = `$${cliente.cargoMensual}`
          cargoCl = `$${cargoCl}`

          let ptosAdic = ""
          if(elemento.listOS.ptosAdic){
            ptosAdic = `PTOS ADIC: ${elemento.listOS.ptosAdic}`
          }
// console.log(ptosAdic)
          let solicit = ""
          let horaSolic = ""
          if(elemento.listOS.nombreSolic){
            solicit = `Solicitante: ${elemento.listOS.nombreSolic}`
          }
          if(elemento.listOS.horaSolic){
            horaSolic = `Hora solicitud: ${elemento.listOS.horaSolic}`
          }
// console.log(cliente.codigoMarquilla)
          let codigoMarquilla = ""
          if(cliente.codigoMarquilla){
            codigoMarquilla = `Marquilla: ${cliente.codigoMarquilla}`
          }

          if(modeloFactura==="1"){
            let imgSource = new Image();
            imgSource.src = "images/logocliente.jpeg";
            doc.convertStringToImageData(imgSource)
            doc.addImage(imgSource, 'PNG', 12, 12, 66, 20, 'logo');
          
            doc.setFontSize(10);
            doc.setFontType("bold");
            doc.setFontStyle("italic");
            doc.text(empresa.empresaRazonSocial, 40, 33, 'center')

            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(`NIT. ${empresa.empresaNit}`, 40, 37, 'center')
            doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, 40, 40, 'center')

            doc.setDrawColor("green")
            doc.lines([[70,0],[0,32],[0-70,0]], 80,10, [1,1], 'S', true)
            doc.line(80, 18, 150, 18)
            doc.line(80, 26, 150, 26)
            doc.line(80, 34, 150, 34)
            doc.setFontSize(12);
            doc.setFillColor("green")
            doc.lines([[35,0],[0,8],[0-35,0]], 80,10, [1,1], 'F', true)
            doc.setTextColor("white")
            doc.setFontType("bold");
            doc.text("CONTRATO:", 82, 15)
            doc.setFontType("bold");
            doc.setTextColor("green")
            doc.text(listOS.contrato, 132, 15, 'center')
            doc.text(`OS: ${listOS.numeroOS}`, 154, 15)

            if(listOS.tipoos.descrTipoOS.length>=25){
              doc.setFontSize(8);
            }else{
              if(listOS.tipoos.descrTipoOS.length>=24){
                doc.setFontSize(9);
              }else{
                if(listOS.tipoos.descrTipoOS.length>=21){
                  doc.setFontSize(10);
                }else{
                  if(listOS.tipoos.descrTipoOS.length>=19){
                    doc.setFontSize(11);
                  }
                }
              }
            }

            // console.log(cun)
            if(cun==="SIN"){
              doc.text(`${listOS.tipoos.descrTipoOS}`, 154, 23)
            }else{
              doc.setFontSize(10);
              doc.text(`${listOS.tipoos.descrTipoOS}`, 154, 23)
              doc.text(`CUN: ${cun}`, 154, 25.5)
            }

            doc.setFontSize(6);
            doc.setTextColor("black")
            doc.text("CLIENTE", 82, 21)
            doc.text("DIRECCION", 82, 29)
            doc.text("MUNICIPIO - BARRIO", 82, 37)
            doc.text("FECHA DE", 154, 29)
            doc.text("EJECUCION", 154, 33)
            doc.line(168, 26, 168, 34)
            doc.text("PROGRAMADA", 170, 29)
            doc.text("REAL", 190, 29)
            doc.text("FECHA DE IMPRESION", 154, 37)
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(nombreCli, 82, 25)
            doc.text(linea1DNN, 82, 33)
            doc.text(linea2DNN, 82, 41)
            // doc.setFontSize(12);
            // doc.setFontType("bold");
            // doc.setTextColor("green")
            // doc.text(`${listOS.tipoos.descrTipoOS}`, 154, 25)
            if(listOS.estadoOS==="ABIERTA"){
              doc.text(`${fechaEjec}`, 170, 33)
            }else{
              doc.text(`${fechaEjec}`, 190, 33)
            }
            doc.text(`${fechaImprime}`, 154, 41)
          
            doc.setFillColor("blue")
            doc.lines([[140,0],[0,7],[0-140,0]], 10, 44, [1,1], 'F', true)
            doc.setFontSize(10);
            doc.setTextColor("white")
            doc.setFontType("bold");

            doc.text("SALDO PENDIENTE:", 17, 49)
            doc.text(saldoCl, 56, 49, 'center')
            doc.text("CARGO MENSUAL:", 82, 49)
            doc.text(cargoCl, 126, 49, 'center')

            doc.lines([[54,0],[0,32],[0-54,0]], 152,10, [1,1], 'S', true)
            doc.line(152, 18, 206, 18)
            doc.line(152, 26, 206, 26)
            doc.line(152, 34, 206, 34)

            doc.setFontSize(10);
            doc.setFillColor("green")
            doc.lines([[54,0],[0,7],[0-54,0]], 152, 44, [1,1], 'F', true)
            doc.setTextColor("white")
            doc.setFontType("bold");
            doc.text("OBSERVACION:", 177, 49, 'center')
            doc.setDrawColor("black")
            doc.lines([[140,0],[0,100],[0-140,0]], 10, 54, [1,1], 'S', true)
            doc.lines([[54,0],[0,100],[0-54,0]], 152, 54, [1,1], 'S', true)
            doc.setTextColor("black")
            doc.setFontSize(8);
            doc.setFontType("normal");
            if(linea1DNNAnt&&!elemento.listOS.osQueLaGenero){
              let observOS = doc.splitTextToSize(`DIRECCION ANTERIOR: \n${linea1DNNAnt}` + 
                  `\n${linea2DNNAnt}\n\nTELEFONOS: \n` +  
                  `${elemento.cliente.telefono1} ${elemento.cliente.telefono2} ${elemento.cliente.telefono3}\n\n` + 
                  `TELEFONOS REFERENCIA: \n${elemento.cliente.telefonoRef1} ${elemento.cliente.telefonoRef2}\n\n` + 
                  `${listOS.observacAB}`, 50, 2, 2)
              doc.text(observOS, 154, 58)
            }else{
              let observOS = doc.splitTextToSize(`TELEFONOS: \n` + 
                    `${elemento.cliente.telefono1} ${elemento.cliente.telefono2} ${elemento.cliente.telefono3}\n\n` + 
                    `TELEFONOS REFERENCIA: \n${elemento.cliente.telefonoRef1} ${elemento.cliente.telefonoRef2}\n\n` + 
                    `${listOS.observacAB}`, 50, 2, 2)
              doc.text(observOS, 154, 58)

              // let observOS = doc.splitTextToSize(listOS.observacAB, 50, 2, 2)
              // doc.text(observOS, 177, 58, 'center')
            }
            // doc.setLineWidth(1)
            // doc.setDrawColor("blue")
            doc.setLineWidth(0)
            doc.setDrawColor("black")
            doc.lines([[140,0],[0,40],[0-140,0]], 10, 156, [1,1], 'S', true)
            doc.lines([[54,0],[0,40],[0-54,0]], 152, 156, [1,1], 'S', true)
            doc.text("Observaciones:", 12, 162)
            doc.text("Antes de firmar verifique el", 156, 162)
            doc.text("servicio a entera satisfacción", 156, 166)
            doc.text("Firma del cliente", 177, 192, 'center')
            doc.line(154, 188, 204, 188)
            // doc.setLineWidth(0)
          
            let imgSource1 = new Image();
            imgSource1.src = "images/logocliente.jpeg";
            doc.convertStringToImageData(imgSource1)
            doc.addImage(imgSource1, 'PNG', 12, 202, 196, 60, 'publicidad');

            // console.log(solicit, horaSolic)
            doc.setDrawColor("black")
            if(elemento.listOS.nombreSolic||elemento.listOS.horaSolic){
              doc.line(10, 142, 150, 142)
            }
            doc.text(solicit, 12, 147)
            doc.text(horaSolic, 12, 151)

            doc.autoTable({startY: 54,
                    tableLineColor: "black",
                    tableLineWidth: 0.1,
                    styles: {
                      // font: 'Calibri',
                      fontSize: 9,
                      lineColor: "black",
                      lineWidth: 0.1
                    },
                    headStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 9
                    },
                    bodyStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black"
                    },
                    alternateRowStyles: {
                      fillColor: "white",
                      textColor: "black"
                    },
                    footStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 9
                    },
                    head: [["Recurso"]],
                    body: movColecc,
                    margin: {top: 0, left: 10, right: 66},}
            )
          }
          if(modeloFactura==="2"||modeloFactura==="3"){
            let imgSource = new Image();
            imgSource.src = "images/logocliente.jpeg";
            doc.convertStringToImageData(imgSource)
            doc.addImage(imgSource, 'PNG', 12, 12, 50, 17, 'logo');
          
            doc.setFontSize(10);
            doc.setFontType("bold");
            doc.setFontStyle("italic");
            doc.text(empresa.empresaRazonSocial, 40, 33, 'center')

            // doc.setFont("'Open Sans', san-serif")
            // // doc.setFont('times')
            // // doc.setFontSize(8);

            // doc.setFontSize(10);
            // doc.setFontType("bold");
            // // doc.setFontStyle("italic");
            // doc.text(empresa.empresaRazonSocial, 40, 33, 'center')
  
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(`NIT. ${empresa.empresaNit}`, 40, 37, 'center')
            doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, 40, 40, 'center')
  
            // doc.setDrawColor("green")
            doc.setDrawColor("black")

            doc.lines([[70,0],[0,32],[0-70,0]], 80,10, [1,1], 'S', true)
            doc.line(80, 18, 150, 18)
            doc.line(80, 26, 150, 26)
            doc.line(80, 34, 150, 34)
            doc.setFontSize(12);

            // doc.setFillColor("green")
            // doc.lines([[35,0],[0,8],[0-35,0]], 80,10, [1,1], 'F', true)
            // doc.setTextColor("white")
            doc.setFillColor("black")
            doc.lines([[35,0],[0,8],[0-35,0]], 80,10, [1,1], 'S', true)

            doc.setFontType("bold");
            doc.text("CONTRATO:", 82, 15)
            doc.setFontType("bold");

            // doc.setTextColor("green")
            doc.setTextColor("black")
            doc.text(listOS.contrato, 132, 15, 'center')
            doc.text(`OS: ${listOS.numeroOS}`, 154, 15)
            // console.log(listOS)
            let descrTipoOS = listOS.tipoos.descrTipoOS
            if(listOS.descrCategOST){
              descrTipoOS+=`-${listOS.descrCategOST}`
            }
            if(descrTipoOS.length>=25){
              doc.setFontSize(8);
            }else{
              if(descrTipoOS.length>=24){
                doc.setFontSize(9);
              }else{
                if(descrTipoOS.length>=21){
                  doc.setFontSize(10);
                }else{
                  if(descrTipoOS.length>=19){
                    doc.setFontSize(11);
                  }
                }
              }
            }

            // console.log(cun)
            if(cun==="SIN"){
              doc.text(`${descrTipoOS}`, 154, 23)
            }else{
              doc.setFontSize(10);
              doc.text(`${descrTipoOS}`, 154, 21.5)
              doc.text(`CUN: ${cun}`, 154, 25.5)
            }
  
            doc.setFontSize(6);
            doc.setTextColor("black")
            doc.text("CLIENTE", 82, 21)
            doc.text("DIRECCION", 82, 29)
            doc.text("MUNICIPIO - BARRIO", 82, 37)
            doc.text("FECHA DE", 154, 29)
            doc.text("EJECUCION", 154, 33)
            doc.line(168, 26, 168, 34)
            doc.text("PROGRAMADA", 170, 29)
            doc.text("REAL", 190, 29)
            doc.text("FECHA DE IMPRESION", 154, 37)
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(nombreCli, 82, 25)
            doc.text(linea1DNN, 82, 33)
            doc.text(linea2DNN, 82, 41)
            // doc.setFontSize(12);
            // doc.setFontType("bold");
            // doc.setTextColor("green")
            // doc.text(`${descrTipoOS}`, 154, 25)
            if(listOS.estadoOS==="ABIERTA"){
              doc.text(`${fechaEjec}`, 170, 33)
            }else{
              doc.text(`${fechaEjec}`, 190, 33)
            }
            doc.text(`${fechaImprime}`, 154, 41)
          
            // doc.setFillColor("blue")
            // doc.lines([[140,0],[0,7],[0-140,0]], 10, 44, [1,1], 'F', true)
            doc.lines([[140,0],[0,7],[0-140,0]], 10, 44, [1,1], 'S', true)

            doc.setFontSize(10);
            // doc.setTextColor("white")
            doc.setFontType("bold");
  
            // doc.text("SALDO PENDIENTE:", 17, 49)
            // doc.text(saldoCl, 56, 49, 'center')
            // doc.text("CARGO MENSUAL:", 82, 49)
            // doc.text(cargoCl, 126, 49, 'center')
            doc.text("SALDO PENDIENTE:", 11, 49)
            doc.text(saldoCl, 53, 49, 'center')
            doc.text("CARGO MENSUAL:", 71, 49)
            doc.text(cargoCl, 111, 49, 'center')
            doc.text(ptosAdic, 125, 49)

            doc.lines([[54,0],[0,32],[0-54,0]], 152,10, [1,1], 'S', true)
            doc.line(152, 18, 206, 18)
            doc.line(152, 26, 206, 26)
            doc.line(152, 34, 206, 34)
  
            doc.setFontSize(10);

            // doc.setFillColor("green")
            // doc.lines([[54,0],[0,7],[0-54,0]], 152, 44, [1,1], 'F', true)
            // doc.setTextColor("white")
            doc.setFillColor("black")
            doc.lines([[54,0],[0,7],[0-54,0]], 152, 44, [1,1], 'S', true)

            doc.setFontType("bold");
            doc.text("OBSERVACION:", 177, 49, 'center')
            doc.setDrawColor("black")
            doc.lines([[140,0],[0,56],[0-140,0]], 10, 54, [1,1], 'S', true)
            doc.lines([[54,0],[0,56],[0-54,0]], 152, 54, [1,1], 'S', true)
            doc.setTextColor("black")
            doc.setFontSize(7);
            doc.setFontType("normal");
            if(linea1DNNAnt&&!elemento.listOS.osQueLaGenero){
              let observOS = doc.splitTextToSize(`DIRECCION ANTERIOR: \n${linea1DNNAnt}` + 
                  `\n${linea2DNNAnt}\n\nTELEFONOS: \n` +  
                  `${elemento.cliente.telefono1} ${elemento.cliente.telefono2} ${elemento.cliente.telefono3}\n\n` + 
                  `TELEFONOS REFERENCIA: \n${elemento.cliente.telefonoRef1} ${elemento.cliente.telefonoRef2}\n\n` + 
                  `${listOS.observacAB}`, 50, 2, 2)
              doc.text(observOS, 154, 58)
            }else{
              let observOS = doc.splitTextToSize(`TELEFONOS: \n` + 
                    `${elemento.cliente.telefono1} ${elemento.cliente.telefono2} ${elemento.cliente.telefono3}\n\n` + 
                    `TELEFONOS REFERENCIA: \n${elemento.cliente.telefonoRef1} ${elemento.cliente.telefonoRef2}\n\n` + 
                    `${listOS.observacAB}`, 50, 2, 2)
              doc.text(observOS, 154, 58)

              // let observOS = doc.splitTextToSize(listOS.observacAB, 50, 2, 2)
              // doc.text(observOS, 177, 58, 'center')
            }

            // console.log(codigoMarquilla)
            doc.setFontType("bold");
            doc.text(codigoMarquilla, 177, 109, 'center')
            doc.setFontType("normal");

            doc.setFontSize(8);
            // doc.setLineWidth(1)
            // doc.setDrawColor("blue")
            doc.setLineWidth(0)
            doc.setDrawColor("black")
            // doc.lines([[140,0],[0,40],[0-140,0]], 10, 156, [1,1], 'S', true)
            // doc.lines([[54,0],[0,40],[0-54,0]], 152, 156, [1,1], 'S', true)
            // doc.text("Observaciones:", 12, 162)
            // doc.text("Antes de firmar verifique el", 156, 162)
            // doc.text("servicio a entera satisfacción", 156, 166)
            // doc.text("Firma del cliente", 177, 192, 'center')
            // doc.line(154, 188, 204, 188)

            doc.lines([[140,0],[0,25],[0-140,0]], 10, 111, [1,1], 'S', true)
            doc.lines([[54,0],[0,25],[0-54,0]], 152, 111, [1,1], 'S', true)
            doc.text("Observaciones:", 12, 114)
            doc.text("Antes de firmar verifique el", 162, 114)
            doc.text("servicio a entera satisfacción", 160, 117)
            doc.text("Firma del cliente", 177, 134, 'center')
            doc.line(154, 131, 204, 131)

            // doc.setLineWidth(0)
  
            if(solicit){
              solicit += "    " + horaSolic
            }else{
              solicit += horaSolic
            }
            doc.setDrawColor("black")
            if(elemento.listOS.nombreSolic||elemento.listOS.horaSolic){
              doc.line(10, 106, 150, 106)
            }
            if(modeloFactura==="3"){
              solicit += "    Elaborado por: " + usuarioCreate
            }

            doc.text(solicit, 12, 109)

            doc.autoTable({startY: 54,
                    tableLineColor: "black",
                    tableLineWidth: 0.1,
                    styles: {
                      // font: "'Open Sans', san-serif",
                      fontSize: 9,
                      lineColor: "black",
                      lineWidth: 0.1
                    },
                    headStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 9
                    },
                    bodyStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black"
                    },
                    alternateRowStyles: {
                      fillColor: "white",
                      textColor: "black"
                    },
                    footStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 9
                    },
                    head: [["Recurso"]],
                    body: movColecc,
                    margin: {top: 0, left: 10, right: 66},}
            )

            if(empresa.empresaArchFE==="sinergy"){
              let descrGrupoAfin = elemento.cliente.grupoaf.descrGrupoAfin
              doc.setFontType("bold");
              doc.text(`Grupo Afinidad: ${descrGrupoAfin}`, 60, 58.5)
              doc.setFontType("normal");
            }
            if(empresa.empresaArchFE==="conectic"||empresa.empresaArchFE==="supercable"){
              let recursoRdo = dirmayor.ciudades.zonas.barrios.descrRecursoR?dirmayor.ciudades.zonas.barrios.descrRecursoR:""
              recursoRdo = recursoRdo.substr(0, 40)
              doc.text(recursoRdo, 60, 58.5)

              doc.text("Fecha y Hora de ejecución:   Inicio:                                                       Fin:", 12, 73)
              doc.text("Metraje DROP:", 12, 97)
              doc.text("Inicio:", 31, 97)
              doc.text("Fin:", 50, 97)

              doc.text("cm:", 70, 97)
              doc.text("F56:", 90, 97)

              doc.text("Metraje RG6:", 12, 103)
              doc.text("Inicio:", 31, 103)
              doc.text("Fin:", 50, 103)

              doc.text("Splitter::", 70, 103)
              doc.text("Marquilla:", 90, 103)
            }
            // if(servAsig.length>0){
              doc.autoTable({startY: 76,
                tableLineColor: "black",
                tableLineWidth: 0.1,
                styles: {
                  // font: "'Open Sans', san-serif",
                  fontSize: 9,
                  lineColor: "black",
                  lineWidth: 0.1
                },
                headStyles: {
                  fillColor: "#bdc3c7",
                  textColor: "black",
                  fontSize: 9
                },
                bodyStyles: {
                  fillColor: "#E9E4F0",
                  textColor: "black"
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black"
                },
                footStyles: {
                  fillColor: "#bdc3c7",
                  textColor: "black",
                  fontSize: 9
                },
                head: [["Servicios asignados"]],
                body: servAsig,
                // margin: {top: 0, left: 10, right: 66},}
                margin: {top: 0, left: 10, right: 136},}
              )
            // }

            // if(macCliente.length>0){
              doc.autoTable({startY: 76,
                tableLineColor: "black",
                tableLineWidth: 0.1,
                styles: {
                  // font: "'Open Sans', san-serif",
                  fontSize: 9,
                  lineColor: "black",
                  lineWidth: 0.1
                },
                headStyles: {
                  fillColor: "#bdc3c7",
                  textColor: "black",
                  fontSize: 9
                },
                bodyStyles: {
                  fillColor: "#E9E4F0",
                  textColor: "black"
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black"
                },
                footStyles: {
                  fillColor: "#bdc3c7",
                  textColor: "black",
                  fontSize: 9
                },
                head: [["Eq asignados"]],
                body: macCliente,
                // margin: {top: 0, left: 10, right: 66},}
                margin: {top: 0, left: 80, right: 106},}
              )
            // }

            // if(macOS.length>0){
              doc.autoTable({startY: 76,
                tableLineColor: "black",
                tableLineWidth: 0.1,
                styles: {
                  // font: "'Open Sans', san-serif",
                  fontSize: 9,
                  lineColor: "black",
                  lineWidth: 0.1
                },
                headStyles: {
                  fillColor: "#bdc3c7",
                  textColor: "black",
                  fontSize: 9
                },
                bodyStyles: {
                  fillColor: "#E9E4F0",
                  textColor: "black"
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black"
                },
                footStyles: {
                  fillColor: "#bdc3c7",
                  textColor: "black",
                  fontSize: 9
                },
                head: [["Eq en OS"]],
                body: macOS,
                // margin: {top: 0, left: 10, right: 66},}
                margin: {top: 0, left: 110, right: 66},}
              )
            // }
          }

          if(contList!==listOSCl.length){
            doc.addPage()
          }
        }
      }
      // })
      // let nameDoc = `OS-${listOS.numeroOS}.pdf`
      doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
      // => UTILIZAR
      const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
      // doc.save(nameDoc)

// console.log(actImpresaOS)

      if(actImpresaOS.length>0){
//Crear el pago y su detalle
        let numDocCRUD = 0
        let totDocCRUD = actImpresaOS.length
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(editOdeS)
        }

        actImpresaOS.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

          numDocCRUD += 1
        })

// console.log(argsCrud)
// console.log(totDocCRUD)
        updColecc(crudColecc, argsCrud, totDocCRUD)
      }
    }

      return(
      <div>

    </div> 
    )
  }

// export default ImprOS

export default compose(
  graphql(queries.mutation.editOdeS, {name:'editOdeS'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
)(ImprOS)
